// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"41809501","165":"8b1215cd","227":"02a8e6e8","440":"dd91b199","519":"6aab3140","645":"44162f46","744":"21773ebb","893":"87a083d7","897":"1d92c829","925":"e0fd88a8","945":"7b88d46d"}[chunkId] + ".chunk.js";
};